import { Checkbox } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

type Props = {
  selected: Object;
  setSelected: any;
  moveToNextStep: any;
  option?: {
    mandatoryLevel: number;
    nameLevel: string;
    qtyLevel: number;
    data: any[];
  };
};

const defaultParams = {
  data: [],
  nameLevel: "",
  qtyLevel: Infinity,
  mandatoryLevel: 0,
};

const Item = ({
  selected,
  setSelected,
  item,
  qtyLevel,
  moveToNextStep,
}: any) => {
  const [showSubLevel, setShowSubLevel] = useState(false);

  const addItem = (id: number, isLevel = false) => {
    const value = structuredClone(selected);
    if (value[id] || !isLevel) {
      if (!isLevel) {
        if (value[item?.id]?.has(id)) {
          value[item?.id].delete(id);
        } else {
          if (item.qtySubLevel >= value[item?.id].size) value[item?.id].add(id);
        }
      } else {
        isLevel && setShowSubLevel(false);
        delete value[id];
      }
    } else {
      isLevel && setShowSubLevel(true);
      value[id] = new Set();
      value[id].add(item);
      setTimeout(() => {
        if (!item.subLevelData && qtyLevel === Object.keys(value).length) {
          moveToNextStep(value);
        }
      }, 100);
    }

    setSelected(value);
  };
  return (
    <>
      <div
        className="border-b border-[#e8e3d9] cursor-pointer select-none last:border-b-0"
      >
        <div
          className="flex gap-3 items-start px-1 py-3"
          onClick={() => addItem(item.id, true)}
        >
          <Checkbox
            sx={{ p: 0.25, mt: "-2px" }}
            checked={!!selected?.[item.id] || false}
          />
          <div className="flex-1 min-w-0 flex items-start justify-between gap-3">
            <p className="text-[14px] font-medium text-[#222] leading-5 pr-2">
              {item.name}
            </p>
            {!!item.price && (
              <p className="whitespace-nowrap text-[13px] font-semibold text-[#24513e]">
                +${Number(item.price).toFixed(2)}
              </p>
            )}
          </div>
          <div className="text-gray-500">
            {item?.subLevelData &&
              (showSubLevel ? (
                <KeyboardArrowUpIcon className="!text-[20px]" />
              ) : (
                <KeyboardArrowDownIcon className="!text-[20px]" />
              ))}
          </div>
        </div>
        {item?.subLevelData && (
          <AnimatePresence>
            <motion.div
              className="overflow-hidden"
              initial={{ height: 0 }}
              animate={{ height: showSubLevel ? "auto" : 0 }}
            >
              <div className="border-t border-[#e8e3d9] ml-10">
                {item.subLevelData.map((subItem: any) => (
                  <div
                    className="flex gap-3 items-start py-2.5 cursor-pointer border-b border-[#eee7da] last:border-b-0"
                    key={subItem.id}
                    onClick={() => addItem(subItem?.id)}
                  >
                    <Checkbox
                      sx={{ p: 0.25, mt: "-2px" }}
                      checked={selected?.[item.id]?.has(subItem.id) || false}
                    />
                    <div className="flex-1 min-w-0 flex items-start justify-between gap-3 pr-1">
                      <p className="text-[13px] text-[#222] leading-5 pr-2">
                        {subItem.name}
                      </p>
                      {!!subItem.price && (
                        <p className="whitespace-nowrap text-[12px] font-medium text-[#24513e]">
                          +${Number(subItem.price).toFixed(2)}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        )}
      </div>
    </>
  );
};
const VariantSelection = ({
  selected,
  setSelected,
  moveToNextStep,
  option = defaultParams,
}: Props) => (
  <div className="overflow-y-auto flex flex-col max-h-[38vh]">
    {option.data.map((item, index) => (
      <Item
        item={item}
        index={index}
        selected={selected}
        setSelected={setSelected}
        qtyLevel={option.qtyLevel}
        moveToNextStep={moveToNextStep}
      />
    ))}
  </div>
);

export default VariantSelection;
